import { useCountdown } from "./useCountdown";

// The backend refuses a resend within 60s of the last code (POST
// /auth/resend-otp, 429 + Retry-After), so the link stays off that long.
export const RESEND_COOLDOWN_SECONDS = 60;

/**
 * Ticks a resend cooldown down to zero, starting the moment the screen
 * mounts (a fresh code was just sent) and restartable after a successful
 * resend. `canResend` gates the resend button -- it only re-enables once
 * the countdown reaches 0.
 */
export function useResendCountdown(seconds: number = RESEND_COOLDOWN_SECONDS) {
  const { secondsLeft, isActive, start } = useCountdown(seconds);

  return {
    secondsLeft,
    canResend: !isActive,
    /** Restarts the cooldown; pass a 429's Retry-After to wait that long. */
    restart: (wait: number = seconds) => {
      start(wait);
    },
  };
}
